import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Popover, Row } from 'antd';
import { FieldTimeOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

export default function BoardCardDynamicLastUpdatedIcon({
  placement = 'leftBottom',
  timestamp,
}) {
  const isDragging = useSelector((state) => state.boards.isDragging);

  const days = useMemo(() => {
    if (!timestamp) return 'N/A';
    const now = DateTime.local().startOf('day');
    const lastUpdated = DateTime.fromMillis(timestamp).startOf('day');
    return Math.ceil(now.diff(lastUpdated).as('days'), 10);
  }, [timestamp]);

  const sinceText = useMemo(() => {
    if (!timestamp) return 'N/A';
    return DateTime.fromMillis(timestamp).toLocaleString(DateTime.DATE_MED);
  }, [timestamp]);

  return (
    <Popover
      placement={placement}
      trigger={isDragging ? [] : ['hover']}
      content={`This card was last updated on ${sinceText}`}
    >
      <Row align="middle" className="board-card-days-in-status-container">
        <FieldTimeOutlined />
        <span className="board-card-days-in-status-text">{days}</span>
      </Row>
    </Popover>
  );
}

BoardCardDynamicLastUpdatedIcon.propTypes = {
  placement: PropTypes.string,
  timestamp: PropTypes.number,
};

BoardCardDynamicLastUpdatedIcon.defaultProps = {
  placement: 'leftBottom',
  timestamp: null,
};
